/**
 * The one funding-progress rule of the projects module: every surface that shows a rate computes
 * it here, so no two of them can disagree.
 *
 * Returns null when no rate is computable: no objective, an objective at or below zero, or an
 * unknown collected amount (the funding read failed). Callers render nothing for null, never zero.
 */
export function fundingProgress(collected, objective) {
    if (collected == null || objective == null || objective <= 0)
        return null;
    const percent = Math.round((collected / objective) * 100);
    return { percent, exceeded: percent > 100 };
}
